import * as v from "valibot";

// 组件类型

export const ComponentTypeSchema = v.picklist(["CONTAINERD", "KUBELET"]);
export type ComponentType = v.InferOutput<typeof ComponentTypeSchema>;

// 节点更新状态：
// - Pending: 待更新
// - Updating: 更新中
// - Completed: 已完成
// - Cancelled: 已取消
// - Error: 失败

export const NodeStatusEnumSchema = v.picklist([
  "Cancelled",
  "Completed",
  "Error",
  "Pending",
  "Updating",
]);
export type NodeStatusEnum = v.InferOutput<typeof NodeStatusEnumSchema>;

// 活动状态：
// - Pending: 待处理
// - Updating: 更新中
// - Paused: 已暂停
// - Completed: 已完成
// - Cancelled: 已取消
// - Error: 失败

export const ActivityStatusSchema = v.picklist([
  "Cancelled",
  "Completed",
  "Error",
  "Paused",
  "Pending",
  "Updating",
]);
export type ActivityStatus = v.InferOutput<typeof ActivityStatusSchema>;

// 更新范围：
// - AllInstances: 节点池内所有现有节点
// - SpecificInstances: 仅用户指定的节点
// - NewInstances：新增节点

export const UpdateScopeSchema = v.picklist(["NewInstances", "AllInstances", "SpecificInstances"]);
export type UpdateScope = v.InferOutput<typeof UpdateScopeSchema>;

export const ParamDiffItemSchema = v.object({
  Name: v.nullish(v.string()),
  NewValue: v.nullish(v.string()),
  OldValue: v.nullish(v.string()),
});
export type ParamDiffItem = v.InferOutput<typeof ParamDiffItemSchema>;

export const NodeStatusSchema = v.object({
  InstanceId: v.nullish(v.string()),
  InstanceName: v.nullish(v.string()),
  MachineId: v.nullish(v.string()),
  Reason: v.nullish(v.string()),
  Status: v.nullish(NodeStatusEnumSchema),
});
export type NodeStatus = v.InferOutput<typeof NodeStatusSchema>;

export const LastArgSchema = v.object({
  Name: v.string(),
  Value: v.string(),
});
export type LastArg = v.InferOutput<typeof LastArgSchema>;

export const ArgSchema = v.object({
  Name: v.string(),
  Value: v.string(),
});
export type Arg = v.InferOutput<typeof ArgSchema>;

export const ActivitySchema = v.object({
  Args: v.nullish(v.array(ArgSchema)),
  ComponentType: v.nullish(ComponentTypeSchema),
  CreatedTime: v.nullish(v.pipe(v.unknown(), v.toDate())),
  Info: v.nullish(v.string()),
  LastArgs: v.nullish(v.array(LastArgSchema)),
  NodePoolActivityId: v.nullish(v.string()),
  NodePoolId: v.nullish(v.string()),
  Nodes: v.nullish(v.array(NodeStatusSchema)),
  ParamDiff: v.nullish(v.array(ParamDiffItemSchema)),
  Status: v.nullish(ActivityStatusSchema),
  UpdatedTime: v.nullish(v.pipe(v.unknown(), v.toDate())),
  UpdateScope: v.nullish(UpdateScopeSchema),
});
export type Activity = v.InferOutput<typeof ActivitySchema>;

export const DataSchema = v.object({
  Activities: v.nullish(v.array(ActivitySchema)),
});
export type Data = v.InferOutput<typeof DataSchema>;

// request
export const RequestSchema = v.object({
  ClusterId: v.string(),
  NodePoolId: v.string(),
  ComponentType: v.optional(ComponentTypeSchema),
});
export type Request = v.InferOutput<typeof RequestSchema>;

export const ResponseSchema = v.object({
  Data: v.nullish(DataSchema),
  RequestId: v.nullish(v.string()),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
